import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);


export default new Vuex.Store({
  state: {
    selectedSpeaker: null,
  },
  mutations: {
    setSelectedSpeaker(state, speaker) {
      state.selectedSpeaker = speaker;
    },
  },
  getters: {
    selectedSpeaker(state) {
      return state.selectedSpeaker;
    },
  },
});



// WEBPACK FOOTER //
// ./src/store.js